import { Transaction, formatToolkitListingID, isUndefined } from '@aloft/toolkit-shared';

export function transactionToToolkitListingID(transaction?: Transaction) {
  const { mls, mlsListingID: listingID } = transaction ?? {};

  if (isUndefined(mls) || isUndefined(listingID)) return undefined;
  return formatToolkitListingID({ mls, listingID });
}
